import LangEnum from '../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../stores/Snackbar.store';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { WsErrorsStrategy } from '../types/wsErrorsStrategy.type';

export class InvalidChatAccessStrategy implements WsErrorsStrategy {
  constructor(private readonly translate: TranslateType) {}

  handle() {
    snackbarStore.handleMessage({
      type: 'error',
      message: this.translate(LangEnum.INVALID_CHAT_ACCESS),
    });
  }
}
